import { render, staticRenderFns } from "./goodssaledetails.vue?vue&type=template&id=d9247ba0&scoped=true&"
import script from "./goodssaledetails.vue?vue&type=script&lang=js&"
export * from "./goodssaledetails.vue?vue&type=script&lang=js&"
import style0 from "./goodssaledetails.vue?vue&type=style&index=0&id=d9247ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9247ba0",
  null
  
)

export default component.exports